import {Component, Input, OnInit} from '@angular/core';
import {I18nService} from '@shared/services/i18n.service';
import {
  JsonArrayHtmlCode,
  OrderDetailInterface,
  ToolInterface
} from '../../../../models/sharedinterface';
import {HttpClient} from '@angular/common/http';
import {ShareddataService} from '@shared/services/shareddata.service';

@Component({
  selector: 'app-generic-orders-edit',
  templateUrl: './generic-orders-edit.component.html',
  styleUrls: ['./generic-orders-edit.component.scss']
})
export class GenericOrdersEditComponent implements OnInit {

  @Input() currentTool: ToolInterface;
  @Input() currentOrder: OrderDetailInterface;
  loadedOrder: OrderDetailInterface;

  htmlCode: string;

  constructor(
    public i18n: I18nService,
    private http: HttpClient,
    private sharedData: ShareddataService
  ) { }

  ngOnInit(): void {
    // Create order endpoint
    const orderlistdetailapi = this.currentTool.orderlistdetailapi;

    if (orderlistdetailapi !== '') {
      const orderId = this.currentOrder.id;
      const language = this.sharedData.getCurrentlanguage();
      const mandant = this.sharedData.getMandantLabel();
      const orderEndPoint = orderlistdetailapi + '/' + orderId + '?mandant=' + mandant + '&languageKey=' + language.key;

      this.http.get<JsonArrayHtmlCode>(orderEndPoint).subscribe( data => {
        // this.loadedOrder = data.results;
        this.htmlCode = data.results;
      } );
    } // if
  }

  renderValue(value: any): string {
    switch (typeof value) {
      case 'object':
        return JSON.stringify(value, null, 2);
      default:
        return value;
    } // switch
  }

  isObject(value:any): boolean {
    if (typeof value === 'object') {
      return true;
    } // if
    return false;
  }

}
